<!-- 沪深总市值 -->
<template>
  <div  class="hSValues-wrap">
    <vue-loading 
      v-if="isshowloading"
      type="bars" 
      color="#d9544e" 
      :size="{ width: '50px', height: '50px' }"
    ></vue-loading>
    <div class="tabs">
      <div
        v-for="(item, i) in tab.text"
        :ref="'hs' + i"
        :class="['tab', i === tab.index  && 'active']"
        :key=i
        @click="tab.index = i;changetab()"
      >{{item}}</div>
      <div :ltip="szmessage" class="tips"></div>
    </div>
    
    <div         
      class="debug"
      v-show="tab.index === 0">
      <ChartTpl
        ref="hSValuesCircle0"
        :enableResize='true'
        :elementId='"hSValuesCircle0"'
        :width='"100%"'
        :height='"120px"'
        :option='circleOption0'
        :originData='circleData0'
      ></ChartTpl>
      <ChartTpl
        ref="hSValuesLines0"
        :enableResize='true'
        :firstTooltip='true'
        :elementId='"hSValuesLines0"'
        :width='"100%"'
        :height='"248px"'
        :option='lines'
        :originData='linesData'
      ></ChartTpl>
    </div>
    <template v-if="alreadyLoad1">
      <div 
        v-show="tab.index === 1"
      >
        <ChartTpl
          ref="hSValuesCircle1"
          :enableResize='true'
          :elementId='"hSValuesCircle1"'
          :width='"100%"'
          :height='"120px"'
          :option='circleOption1'
          :originData='circleData1'
        ></ChartTpl>
        
        <ChartTpl
        :enableResize='true'
        :firstTooltip='true'
        :elementId='"hSValuesLines1"'
        ref="hSValuesLines1"
        :width='"100%"'
        :height='"248px"'
        :option='lines2'
        :originData='linesData2'
      ></ChartTpl>
        
      </div>
    </template>

  </div>
</template>

<script>
import ChartTpl from '@/components/ChartTpl.vue';
import { VueLoading } from 'vue-loading-template';

export default {
  name: "HSValues",
  components: {
    ChartTpl,
    VueLoading
  },
  props: {
    elementId: {
      type: String,
      default: "hello"
    },
    dualMarketValue:{
      type: Object,
      default: function () {
        return {}
      }
    },
    SHSZvalueseries:{
      type: Array,
      default: function () {
        return []
      }
    }
    
  },
  data() {
    return {
      tab: {
        index: 0,
        text: ["沪深总市值", "沪深成交金额"]
      },
      szmessage: '沪深总市值：沪深两市总市值',
      alreadyLoad1: false,
      circleOption0: {},
      circleData0:[],
      circleOption1: {},
      circleData1:[],
      lines2: {},
      linesData2: [],
      lines: {},
      linesData: [],
      dualTurnover: {},
      trading_money_emo_series: [],
      isshowloading: false
    };
  },
  watch: {
    'tab.index':{
      handler(newvalue, oldvalue){
        let alreadyLoadStr = 'alreadyLoad'+newvalue;
        let getDataStr = 'getData'+newvalue;

        if (newvalue !== 0) {
          if(!this[alreadyLoadStr]) this[getDataStr]();
          this[alreadyLoadStr] = true;
        }

        setTimeout(()=>{
          this.$refs['hSValuesCircle'+newvalue].resize();
          this.$refs['hSValuesLines'+newvalue].resize();
        })
      }
    },
    SHSZvalueseries: {
      handler(newvalue, oldvalue){
        this.init();
      }
    },
    trading_money_emo_series:{
      handler(newvalue, oldvalue){
        this.initLine2();
      }
    }
  },
  mounted() {
    this.report()
    LTip.width = 200;
    LTip.pos = 'right' ;
    LTip.theme = 'black';
    LTip.reBind();

    if(!this.SHSZvalueseries.length) return;
    this.init();
  },
  methods: {
    report () {
      let ta = [{ id: 'pcweb_hgdata_hszsz' }, { id: 'pcweb_hgdata_hscjje' }]
      for (let i = 0; i < 2; i++) {
        let elm = this.$refs['hs'+i][0]
        TA.logElementClick(elm, ta[i])
      }
    },
    changetab(){
      if(this.tab.index == 0)
      {
        this.szmessage = '沪深总市值：沪深两市总市值'
      }
      if(this.tab.index == 1)
      {
        this.szmessage = '沪深成交金额：沪深两市成交金额'
      }
    },
    getData1(){
      this.isshowloading = true;
      this.$api.blockAPI
        .getTradingMoneySeries()
        .then(res => {
          if (res.code === 0) {
            this.dualTurnover = res.data.dualTurnover;
            this.trading_money_emo_series = res.data.trading_money_emo_series;
            this.isshowloading = false;
          }
        })
        .catch(e => {});
    },
    initCircle(){
      let { SH, SZ } = this.dualMarketValue;
      this.circleOption0 = this.$chartConfigs.doubleCircle();
      this.circleOption0.data[0] = {
        originData: [{
          min: 0,
          max: 1,
          title: '深市总市值',
          values: [
            {
              value: SZ.percentile,
              show: SZ.value 
            }
          ]
        },{
          min: 0,
          max: 1,
          title: '沪市总市值',
          values: [
            {
              value: SH.percentile,
              show: SH.value 
            }
          ]
        }]
      };

      this.circleData0 = this.circleOption0.data;
    },
    initCircle2(){
      let { dualTurnover, emoIndicator } = this.dualTurnover;
      this.circleOption1 = this.$chartConfigs.doubleCircle();
      this.circleOption1.data[0] = {
        originData: [{
          min: 0,
          max: 1,
          title: '沪深成交额',
          values: [
            {
              value: dualTurnover.percentile,
              show: dualTurnover.value 
            }
          ]
        },{
          min: 0,
          max: 1,
          title: '市场情绪指标',
          values: [
            {
              value: emoIndicator.percentile,
              show: emoIndicator.value 
            }
          ]
        }]
      };

      this.circleData1 = this.circleOption1.data;
    },
    initLine2(){
      this.initCircle2()
      this.lines2 = this.$chartConfigs.line2DoubleAxis({
        line1:{
          name:'沪深成交额', 
          lineColor: this.$chartConfigs.projectColors.blue,
          dataKey:'trading_money'
        },
        line2:{
          name:'市场情绪', 
          lineColor: this.$chartConfigs.projectColors.red,
          dataKey:'market_emo_indicator'
        }
      });
      this.linesData2 = [{
        originData: this.trading_money_emo_series
      }]
    },
    initLine(){
      this.lines = this.$chartConfigs.line3({
        line1:{
          name:'深市',
          dataKey: 'SZ_value'
        },
        line2:{
          name:'沪市',
          dataKey: 'SH_value',
          lineColor: this.$chartConfigs.projectColors.red
        },
        line3:{
          name:'沪深综合',
          dataKey: 'trading_value',
          lineColor: this.$chartConfigs.projectColors.yellow
        }
      });
      
      this.linesData = [{
        originData: this.SHSZvalueseries
      }]
    },
    init(){
      this.initLine();
      this.initCircle();
    }
  }
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
</style>
<style lang="scss" scoped>
.hSValues-wrap{
  font-size: 14px;
}
.tabs {
  display: flex;
  margin-bottom: 10px;
  flex: 0 0 auto;
  align-items: center;
  /* font-weight: 700; */
}
.tab {
  border: 1px solid #3b3c41;
  padding: 2px 12px;
  margin-left: -1px;
  cursor: pointer;
}
.tab.active {
  background: #3b3c41;
  color: #fff;
  cursor: default;
}
.select-style {
  color: #ffffff !important;
  background-color: #3b3c41;
}
.tips {
  position: relative;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
  vertical-align: middle;
  margin-left:10px;
  width:18px;
  height: 16px;
}
.vue-loading {
  position: absolute;
  top: 50%;
  left: 40%;
  z-index: 9999;
}
</style>
